import api from '.'

// Client for the food-diary feature. Food search is trial-scoped (proxied
// server-side so the external food-database key never reaches the browser);
// entries are participant-scoped CRUD.
export const foodDiaries = {
  searchFoods (trialId, q, { limit = 25, offset = 0 } = {}, success, fail) {
    const params = new URLSearchParams({ q, limit: String(limit), offset: String(offset) })
    api.authenticatedRequest('GET', `/trials/${trialId}/food-search?${params}`, null, success, fail)
  },
  listEntries (trialId, participantId, { date, from, to } = {}, success, fail) {
    const params = new URLSearchParams()
    if (date) params.set('date', date)
    if (from) params.set('from', from)
    if (to) params.set('to', to)
    const qs = params.toString() ? `?${params}` : ''
    api.authenticatedRequest('GET', `/trials/${trialId}/participants/${participantId}/foodDiaryEntries${qs}`, null, success, fail)
  },
  createEntry (trialId, participantId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/participants/${participantId}/foodDiaryEntries`, data, success, fail)
  },
  updateEntry (trialId, participantId, entryId, data, success, fail) {
    api.authenticatedRequest('PUT', `/trials/${trialId}/participants/${participantId}/foodDiaryEntries/${entryId}`, data, success, fail)
  },
  deleteEntry (trialId, participantId, entryId, success, fail) {
    api.authenticatedRequest('DELETE', `/trials/${trialId}/participants/${participantId}/foodDiaryEntries/${entryId}`, null, success, fail)
  }
}
